import styled from 'styled-components';

interface PremiumContainerProps {
  size: 'small' | 'medium' | 'large';
}

export const PremiumContainer = styled.div<PremiumContainerProps>`
  position: relative;

  .numbers {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .pay-period {
    padding-left: 4px;
    position: relative;

    ${({ size }) => size === 'large' && 'top: 4px;'}
  }
`;
